import { useState } from "react";
import { useDisclosure } from "@chakra-ui/react";

interface UseRevisionModalReturn {
  isOpen: boolean;
  revisionText: string;
  onOpen: () => void;
  onClose: () => void;
  onChangeRevisionText: (text: string) => void;
  clearRevisionText: () => void;
}

export const useRevisionModal = (): UseRevisionModalReturn => {
  const [revisionText, setRevisionText] = useState("");
  const {
    isOpen: isRevisionModalOpen,
    onOpen: onRevisionModalOpen,
    onClose: onRevisionModalClose,
  } = useDisclosure();

  const onChangeRevisionText = (text: string) => {
    setRevisionText(text);
  };

  const clearRevisionText = () => {
    setRevisionText("");
  };

  return {
    isOpen: isRevisionModalOpen,
    revisionText,
    onOpen: onRevisionModalOpen,
    onClose: () => {
      onRevisionModalClose();
      clearRevisionText();
    },
    onChangeRevisionText,
    clearRevisionText,
  };
};
